import { PrimeIcons } from "primereact/api";
import {
  labelAperta,
  labelArchiviata,
  valueAperta,
  valueArchiviata,
} from "_constants";

export const ReportStateChip = ({
  type,
}: {
  type: "APERTA" | "ARCHIVIATA";
}) => {
  return (
    <div
      className={`container-visibility report-${
        type === "APERTA" ? valueAperta : valueArchiviata
      }`}
    >
      <i
        className={
          type === "APERTA" ? PrimeIcons.EXCLAMATION_CIRCLE : PrimeIcons.CHECK
        }
      ></i>
      <small className="small font-weight-600">
        {type === "APERTA" ? labelAperta : labelArchiviata}
      </small>
    </div>
  );
};
